export const EmptyOrderKind = {
  kindId: 0,
  typeId: 0,
  kindName: "",
  width: 0,
  height: 0,
};
